export default {
	module: 'labels',
	actions: {
		list: true,
		create: true,
		dynamicPaths: [
			{
				paths: {
					'/labels/edit/:id': true,
				},
				keys: {
					':id': 3
				}
			},
		]
	}
}

